module.exports = __webpack_public_path__ + "img/search-no-data.145e40e6.png";